<template>
	<t-input-wrapper
		:label="label"
		:description="description"
		:hint="hint"
		:isInvalid="isInvalid"
		:validationMessage="validationMessage"
		:warningMessage="warningMessage"
	>
		<textarea
			ref="textarea"
			:style="getStyle"
			:value="value"
			:class="[{invalid: isInvalid, disabled: disabled}]"
			:placeholder="placeholder"
			:disabled="disabled"
			:aria-disabled="disabled"
			class="text-area"
			v-on="inputListeners"
		/>
	</t-input-wrapper>
</template>

<script>
import formMixin from './formMixin';
import inputWrapperMixin from './inputWrapperMixin';
import TInputWrapper from './TInputWrapper';
export default {
	name: 'TTextArea',
	components: { TInputWrapper },
	mixins: [ formMixin, inputWrapperMixin ],
	props: {
		height: {
			type: String,
			default: '80px'
		},
		minHeight: {
			type: String,
			default: '80px'
		},
		maxHeight: {
			type: String,
			default: 'none',
		},
		resize: {
			type: String,
			default: 'both',
			validator: (value) => [ 'both', 'horizontal', 'vertical', 'none' ].indexOf(value) !== -1,
		},
		autoFocus: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		getStyle() {
			return {
				width: this.width,
				paddingLeft: this.paddingLeft,
				resize: this.resize,
				height: this.height,
				minHeight: this.minHeight,
				maxHeight: this.maxHeight
			};
		},
	},
	mounted() {
		if (this.autoFocus) {
			document.activeElement.blur();
			this.$refs.textarea.focus();
		}
	}
};
</script>

<style lang="scss" scoped>
@import './scss/form';
</style>


<docs>
```jsx
<div>
	<t-text-area placeholder="Placeholder text..."></t-text-area>
</div>
```
</docs>